import React, { createContext, useContext, useMemo, useState } from 'react';

const ActiveEditorContext = createContext(null);

export const ActiveEditorProvider = ({ children }) => {
  const [activeEditorId, setActiveEditorId] = useState(null);

  const value = useMemo(() => ({
    activeEditorId,
    openEditor: (editorId) => {
      setActiveEditorId(editorId || null);
    },
    closeEditor: (editorId) => {
      setActiveEditorId((current) => (current === editorId ? null : current));
    },
    isEditorOpen: (editorId) => activeEditorId === editorId,
  }), [activeEditorId]);

  return (
    <ActiveEditorContext.Provider value={value}>
      {children}
    </ActiveEditorContext.Provider>
  );
};

export const useActiveEditor = () => {
  const context = useContext(ActiveEditorContext);
  if (!context) {
    throw new Error('useActiveEditor must be used within an ActiveEditorProvider');
  }
  return context;
};
